import { IDialogAction } from './IDialogAction';
import { DialogSignalRService } from '../services/DialogSignalRService';
import { Store } from 'redux';
import { DialogState } from '../models/DialogState';

export const CHANGE_TAB = 'CHANGE_TAB';

export class ChangeTabAction implements IDialogAction {
    public readonly type = CHANGE_TAB;
    public constructor(public payload: any, private _service?: DialogSignalRService) {}
    public middleware(store: Store): any {
        if(this._service) {
            let state = store.getState() as DialogState;
            let seq = state.feed.tabs
                .filter(t => { return t.id === state.feed.currentTabId })
                .map(t => { return t.sequence });
            this._service.changeTab(this.payload.id, seq[0]);
        }
        return;
    }
    public reducer(state: DialogState): DialogState {
        state.feed.messagesReady = false;
        state.feed.currentTabId = this.payload.id;
        state.feed.messages = [];
        state.feed.audienceFilters = [];
        state.feed.tabs.filter(t => t.id == this.payload.id).forEach(t => {
            t.addedMessages = [];
            t.notification = 0;
        });
        return state;
    }
}

export const ChangeTabActionTypeMapping = {
    [CHANGE_TAB]: ChangeTabAction
};